var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outlined/UI/paper") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navbar-new",
    transform: "translate(-31.000000, -827.000000)",
    fill: "#418AFE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined/UI/paper",
    transform: "translate(31.437500, 827.062500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.594375,0 L15.125,4.53062501 L15.125,15.8125 C15.125,16.9515873 14.2015873,17.8750001 13.0625,17.8750001 L2.06250001,17.8750001 C0.923412706,17.8750001 0,16.9515873 0,15.8125 L0,0 L10.594375,0 Z M8.93750003,1.375 L1.375,1.375 L1.375,15.8125 C1.375,16.1921958 1.68280424,16.5000001 2.06250001,16.5000001 L13.0625,16.5000001 C13.4421958,16.5000001 13.75,16.1921958 13.75,15.8125 L13.75,6.18750002 L11,6.18750002 C9.86091273,6.18750002 8.93750003,5.26408731 8.93750003,4.12500001 L8.93750003,1.375 Z M7.56250002,11 L7.56250002,12.375 L4.12500001,12.375 L4.12500001,11 L7.56250002,11 Z M11,8.25000003 L11,9.62500003 L4.12500001,9.62500003 L4.12500001,8.25000003 L11,8.25000003 Z M10.3125,1.65687501 L10.3125,4.12500001 C10.3125,4.50469578 10.6203043,4.81250002 11,4.81250002 L13.468125,4.81250002 L10.3125,1.65687501 Z",
    id: "Style"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsSvg);
export default __webpack_public_path__ + "static/media/Documents_svg.afebfc925e1d48a86c65fbd4f319af5d.svg";
export { ForwardRef as ReactComponent };